export const IRROLE = "IR"

